<template>
  <div class="supplier-page">
    <div class="page-header-bar">
      <div class="page-header-title">
        <h2>供应商详情</h2>
      </div>
      <div class="page-header-tool">
        <!-- // -->
      </div>
    </div>

    <div class="supplier-details-info">
      <table>
        <tr>
          <td class="sdit_t">供应商名称</td>
          <td class="sdit_c">
            {{ supplier_detail.supplierName }}
            <el-tag type="danger" size="small" v-if="supplier_detail.status == 0">{{ supplier_detail.statusstr }}</el-tag>
            <el-tag type="success" size="small" v-if="supplier_detail.status == 1">{{ supplier_detail.statusstr }}</el-tag>
          </td>
          <td class="sdit_t">供应商渠道</td>
          <td class="sdit_c">{{ supplier_detail.channelname }}</td>
          <td class="sdit_t">可用额度</td>
          <td class="sdit_c">{{ supplier_detail.availableCredit }}</td>
          <td class="sdit_t">单价</td>
          <td class="sdit_c">{{ supplier_detail.unitPrice }}</td>
        </tr>
        <tr>
        </tr>
        <tr>
          <td class="sdit_t">最近充值时间</td>
          <td class="sdit_c">{{ supplier_detail.lastRechargeTime }}</td>
          <td class="sdit_t">最近充值金额</td>
          <td class="sdit_c">{{ supplier_detail.lastRechargeAmount }}</td>
          <td class="sdit_t">累计充值</td>
          <td class="sdit_c">{{ supplier_detail.totalRecharge }}</td>
          <td class="sdit_t"></td>
          <td class="sdit_c"></td>
        </tr>
        <tr>
          <td class="sdit_t">QQ</td>
          <td class="sdit_c">{{ supplier_detail.qq }}</td>
          <td class="sdit_t">微信</td>
          <td class="sdit_c">{{ supplier_detail.wechat }}</td>
          <td class="sdit_t">电话</td>
          <td class="sdit_c">{{ supplier_detail.tel }}</td>
          <td class="sdit_t">网址</td>
          <td class="sdit_c">{{ supplier_detail.url }}</td>
        </tr>
        <tr>
          <td class="sdit_t">备注</td>
          <td class="sdit_c" colspan="7">{{ supplier_detail.remarks }}</td>
        </tr>
      </table> 
    </div>

    <div class="tablebox supplier-details-table">
      <div class="page-header-bar">
        <div class="page-header-title">
          <h2>额度记录</h2>
        </div>
        <div class="page-header-tool">
          <!-- // -->
        </div>
      </div>
      <el-table :data="lists" size="small">
        <el-table-column label="#" prop="id" width="50"></el-table-column>
        <el-table-column label="充值金额" prop="unitPrice" width="150"></el-table-column>
        <el-table-column label="充值额度" prop="availableCredit" width="150"></el-table-column>
        <el-table-column label="充值时间" prop="rechargeTime" width="150"></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      lists: [],
      supplier_detail: {}
    }
  },

  mounted(){
    this.getSupplier()
    this.getSupplierDetail()
  },

  methods: {

    /**
     * 获取详情
     */
    getSupplierDetail: function(){
      let that = this
      let url = that.API_URL + '/sys/suppliers/detailList?supplierId=' + that.$route.params.Id
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          let _data = data.results
          _data.forEach(item => {
            item.rechargeTime = that.$moment(item.createtime).local().format('YYYY-MM-DD HH:mm')
          })
          that.lists = _data
        },
        error: function(response) {
          console.log('getPackage', response)
        }
      })      
    },
    
    /**
     * 供应商详情
     */
     getSupplier: function(){
      let that = this
      let url = that.API_URL + '/sys/suppliers/list?supplierId=' + that.$route.params.Id
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          let _data = data.results[0][0]
          that.supplier_detail = _data
          that.supplier_detail.channelname = that.formatChannelStr(_data.channelId)
          that.supplier_detail.statusstr = that.formatStatusStr(_data.status)
          that.supplier_detail.lastRechargeTime = that.$moment(_data.lastRechargeTime).local().format('YYYY-MM-DD HH:mm')
        },
        error: function(response) {
          console.log('getSupplier', response)
        }
      })
    },

    formatChannelStr: function(id){
      let src = ''
      id = id * 1
      switch (id) {
        case 1:
          src = "淘宝";
          break;
        case 2:
          src = '天猫';
          break;
        case 3:
          src = "京东";
          break;
        case 30:
          src = '拼多多';
          break;
        case 45:
          src = '抖音';
          break;
        case 56:
          src = '得物';
          break;
      }
      return src
    },

    formatStatusStr: function(id){
      let src = ''
      id = id * 1
      switch (id) {
        case 0:
          src = "停用";
          break;
        case 1:
          src = '正常';
          break;
      }
      return src
    }

  }
}
</script>